import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Fade from '@mui/material/Fade'
import { useEffect } from 'react'

import { AppChooserDialog } from '../components/app-chooser/AppChooserDialog'
import { LoginHeader } from '../components/CardHeader'
import { LoginLayout } from '../components/layout/LoginLayout'
import { LoadingIndicator } from '../components/LoadingIndicator'
import { LoginCard } from '../components/LoginCard'
import { LoginFooter } from '../components/LoginFooter'
import { LoginForm } from '../components/LoginForm'
import { useAuth } from '../context/AuthContext'
import {
  navigateToApp,
  navigateToService,
  shouldChooseApp
} from '../utils/navigation'

/**
 * Modern login page component
 * Handles authentication and navigation for users
 * based on their role
 */
const Login = () => {
  const { login, loading, isAuthenticated, user } = useAuth()

  const needsAppChoice =
    isAuthenticated &&
    user !== null &&
    shouldChooseApp(user.role, window.location.hostname)

  useEffect(() => {
    if (isAuthenticated && user && !needsAppChoice) {
      navigateToService(user)
    }
  }, [isAuthenticated, user, needsAppChoice])

  if (loading) {
    return (
      <LoginLayout>
        <LoadingIndicator />
      </LoginLayout>
    )
  }

  return (
    <LoginLayout>
      <Container maxWidth="xs" sx={{ position: 'relative', zIndex: 1 }}>
        <Fade in timeout={800}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            {/* Logo and Brand */}
            <LoginHeader />

            {/* Login Card */}
            <LoginCard>
              <LoginForm login={login} />
            </LoginCard>

            {/* Footer */}
            <LoginFooter />
          </Box>
        </Fade>
      </Container>
      <AppChooserDialog open={needsAppChoice} onSelect={navigateToApp} />
    </LoginLayout>
  )
}

export default Login
